// @ts-nocheck
import objectKeys from "@store/Framework/Common/Utilities/objectKeys";
import { ContactUsTopicsFormFieldValues } from "@store/Framework/Store/Greif/Components/ContactUsTopicsForm/ContactUsTopicsFormState";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";
import isEqual from "lodash/isEqual";

type HandlerType = Handler<Partial<ContactUsTopicsFormFieldValues>>;

export const DispatchSetDraftFieldValuesIfNeeded: HandlerType = props => {
    const { formDraftFieldValues } = props.getState().greif.components.contactUsTopicsForm;

    if (!objectKeys(props.parameter)?.some(x => !isEqual(props.parameter[x], formDraftFieldValues[x]))) {
        return;
    }

    props.dispatch({
        type: "Greif/Components/ContactUsTopicsForm/SetDraftFieldValues",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetDraftFieldValuesIfNeeded];

const setDraftFieldValues = createHandlerChainRunner(chain, "SetDraftFieldValues");

export default setDraftFieldValues;
